import React, { useMemo } from "react";

import { Language, Order } from "../../../../../../../services";
import useOfferExpired from "../../../../../../../hooks/useOfferExpired";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const ExecutorCallSignCellContent: React.FC<
	ExecutorCallSignCellContent.Props
> = ({ item }) => {
	const offerExpired = useOfferExpired(item);

	const { content, backgroundColor, textColor } = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const preparedCell = item?.cellsForTable?.[ColumnId.ExecutorCallSign];

		if (!offerExpired && isCellsReady && preparedCell) {
			return preparedCell;
		}

		return cellProcessing(item, { offerExpired });
	}, [item, offerExpired]);

	return (
		<CellContentRoot
			alignItems="center"
			backgroundColor={backgroundColor}
			textColor={textColor}
			h="100%"
			w="100%"
		>
			{content}
		</CellContentRoot>
	);
};

declare namespace ExecutorCallSignCellContent {
	interface Props {
		item: Order.Model;
		language: Language;
	}
}

export default ExecutorCallSignCellContent;
